import * as React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import AppFrame from './pages/layout';
import Home from './pages/home';
import Login from './pages/login/loginPage';
import ForgotPassword from './pages/login/forgotPasswordPage';
import Channel from './pages/channel/channelPage';
import Episode from './pages/episode/episodePage';
import Bible from './pages/bible/biblePage';
import ReadingPlan from './pages/readingPlan/readingPlanPage';
import Reading from './pages/reading/readingPage';
import Language from './pages/language/languagePage';
import MessageBoard from './pages/messageBoard/messageBoardPage';
import DashBoard from './pages/dashboard/dashboardPage';
import User from './pages/user/userPage';
import 'bootswatch/dist/litera/bootstrap.min.css';
import './assets/styles/dab.css';
import ReactNotification from 'react-notifications-component';
import { clearCache, clearRefreshToken, getCookie, handleTime } from './pages/common/functions';
import packageJson from '../package.json';
import SessionTimeout from './components/dab/SessionTimeout';
import Front from './pages/frontApp/frontPage';
import PageNotFound from './pages/pageNotFound';
import { clearStorageValues, getAuthData, setAuthData } from './services/selectors/Accounts';
import AuthRoute from './pages/common/AuthRoute';
import Unauthorized from './pages/unauthorised';
import { loginAction } from './actions/loginAction'; 
import VideoHotline from './pages/videoHotline/videoHotlinePage'; 
import Testimonial from './pages/testimonial/testimonialPage';
import PromiseLand from './pages/promiseLand/promiseLandPage';
import Settings from './pages/settings/settingPage';
import DABFilms from './pages/dabFilms/dabFilmsPage';
import Musics from './pages/musics/musicsPage';
import ManageMusicPlatform from './pages/musics/manageMusicPlatform/musicPlatformPage';
import PrayerAndTalks from './pages/prayer-talks/prayerAndTalksPage'; 
import ManageCategoryPageComponent from './pages/manage-category/manageCategoryPage';
import VideoHotlineCategoryPageComponent from './pages/videoHotline/videoHotlineCategory/videoHotlineCategoryPage';
import ResourcePage from './pages/resource/resourcePage';
import ReleaseNotificationPage from './pages/releaseNotification/releaseNotificationPage';
import RatingSettingPage from './pages/ratingSetting/ratingSettingPage';
import RatingPage from './pages/rating/ratingPage';

interface IAppProps {
	dispatch: Dispatch<any>;
	loginData: any;
}

const App: React.SFC<IAppProps> = ({ dispatch, loginData }) => {

	const [isLogged, setIsLogged] = React.useState(() => {
		const loggedInData = getAuthData();
		return loggedInData ? loggedInData.isSuccess : false;
	})
	const memoryRoute = sessionStorage.getItem('memoryRoute');

	React.useEffect(() => {
		const loggedInData = getAuthData();
		const refreshTokenValue = getCookie("refreshToken") ?
			getCookie("refreshToken") : localStorage.getItem('refreshToken');

		const signedRoutes = ['/', '/dashboard', '/channel', '/episode', '/bible', '/language', '/readingplan',
			'/reading', '/messageboard', '/user', '/front', '/401', '/404', '/unauth', '/forgotpassword','/videohotline', '/testimonial', '/contextualmedia', '/settings', '/dabfilms', '/music', '/prayer-talks', '/managemusicplatform', '/manage-category', '/managehotlinecategory', '/resources', '/app-release-notification', '/manage-rating-settings', '/ratings'];

		const unSignedRoutes = ['/login', '/front']
		const path = window.location.pathname;

		if (loggedInData) {
			setIsLogged(loggedInData.isSuccess);

			if (unSignedRoutes.some(route => path.toLowerCase() === route)
				&& path.toLowerCase() != '/forgotpassword') {
				path != '/front' ? window.location.href = "/" : ""
			}
			else {
				if (!signedRoutes.some(route => path.toLowerCase() === route)) {
					window.location.href = "/404"
				}
			}

		} else if (!loggedInData && refreshTokenValue && refreshTokenValue.length > 0) {
			signedRoutes.some(route => path === route) ?
				!memoryRoute ? sessionStorage.setItem("memoryRoute", path + window.location.search) : "" : ""			
			dispatch(loginAction.getUserByRefreshToken(refreshTokenValue));
		} else {
			if (window.location.pathname !== "/forgotpassword"
				&& window.location.pathname !== "/login"
				&& window.location.pathname !== "/front") {

				signedRoutes.some(route => path === route) ?
					sessionStorage.setItem("memoryRoute", path + window.location.search) : ""
				window.location.href = "/login";
			}
		}
		clearCache(packageJson.version);
	}, [])

	if (loginData) {
		if (loginData.isSuccess && loginData.isRememberMeLoggedIn) {
			setAuthData(loginData);
			handleTime();
			window.location.href = memoryRoute ? memoryRoute : "/";
		}

		if (loginData.loginByRefreshTokenFailed && !loginData.isSuccess && !loginData.isRememberMeLoggedIn) {
			clearRefreshToken();
			clearStorageValues();
			window.location.href = "/login";
		}
	}

	return (
		<BrowserRouter>
			<div data-testid="notification"><ReactNotification /></div>
			{isLogged && (<SessionTimeout />)}
			<Switch>
				<AppFrame isLogged={isLogged}>
					{isLogged ?
						<>
							<AuthRoute exact path='/' roles={['Admin', 'Channel', 'Community']} component={Home} />
							<AuthRoute path='/dashboard' roles={['Admin', 'Community']} component={DashBoard} />
							<AuthRoute path='/channel' roles={['Admin', 'Channel']} component={Channel} />
							<AuthRoute path='/episode' roles={['Admin', 'Episode', 'Channel']} component={Episode} />
							<AuthRoute path='/bible' roles={['Admin', 'Channel']} component={Bible} />
							<AuthRoute path='/language' roles={['Admin', 'Channel']} component={Language} />
							<AuthRoute path='/readingplan' roles={['Admin', 'Channel']} component={ReadingPlan} />
							<AuthRoute path='/reading' roles={['Admin', 'Channel']} component={Reading} />
							<AuthRoute path='/messageboard' roles={['Community', 'Admin']} component={MessageBoard} />
							<AuthRoute path='/user' roles={['Admin', 'Community', 'Channel', 'Episode']} component={User} />
							<AuthRoute path='/front' roles={['Admin', 'Community']} component={Front} />
							<AuthRoute path='/videohotline' roles={['Admin', 'Channel', 'Episode', 'Community']} component={VideoHotline} />
							<AuthRoute path='/managehotlinecategory' roles={['Admin', 'Channel', 'Episode', 'Community']} component={VideoHotlineCategoryPageComponent} />
							<AuthRoute path='/testimonial' roles={['Admin', 'Channel', 'Episode', 'Community']} component={Testimonial} />
							<AuthRoute path='/contextualmedia' roles={['Admin', 'Channel', 'Episode', 'Community']} component={PromiseLand} />
							<AuthRoute path='/manage-category' roles={['Admin', 'Channel', 'Episode', 'Community']} component={ManageCategoryPageComponent} />
							<AuthRoute path='/settings' roles={['Admin', 'Channel', 'Episode', 'Community']} component={Settings} />
							<AuthRoute path='/dabfilms' roles={['Admin', 'Channel', 'Episode', 'Community']} component={DABFilms} />
							<AuthRoute path='/music' roles={['Admin', 'Channel', 'Episode', 'Community']} component={Musics} />
							<AuthRoute path='/managemusicplatform' roles={['Admin', 'Channel', 'Episode', 'Community']} component={ManageMusicPlatform} />
							<AuthRoute path='/prayer-talks' roles={['Admin', 'Channel', 'Episode', 'Community']} component={PrayerAndTalks} />
							<AuthRoute path='/resources' roles={['Admin']} component={ResourcePage} />
							<AuthRoute path='/app-release-notification' roles={['Admin']} component={ReleaseNotificationPage} />
							<AuthRoute path='/manage-rating-settings' roles={['Admin']} component={RatingSettingPage} />
							<AuthRoute path='/ratings' roles={['Admin']} component={RatingPage} />
							<Route path='/401' component={Unauthorized} />
							<Route path='/unauth' component={Unauthorized} />
							<Route exact path='/404' component={PageNotFound} />
							<Route path='/forgotpassword' component={ForgotPassword} />
						</> :
						<>
							<Route exact path='/' component={Home} />
							<Route path='/login' component={Login} />
							<Route path='/front' component={Front} />
							<Route path='/forgotpassword' component={ForgotPassword} />
						</>}
				</AppFrame>
			</Switch>
		</BrowserRouter>
	);
}
const mapStateToProps = (state: any) => {
	const { loginData } = state;
	return { loginData };
};
export default connect(mapStateToProps)(App);
